module.exports = __webpack_public_path__ + "components/flag/static/square/kg-d8c0cae9a1cc66897a269a0117fc6ac8.svg";